import { ca } from '@cian/analytics';

export const trackModalShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'LK_Packages',
    action: 'Show',
    label: 'PopupToBuy',
  });
};

export const trackConfirmClick = (isAutoprolong: boolean) => {
  const action = isAutoprolong ? 'try_to_buy_prolong' : 'try_to_buy';

  ca('eventSite', {
    name: 'oldevent',
    category: 'LK_Packages',
    action,
    label: 'BuyOffer',
  });
};

export const trackCancelClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'PersonalOffers',
    action: 'Click',
    label: 'CancelOffer',
  });
};
